import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/activeNavbarItem.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f102295"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  key: 0,
  class: "loggeduser_div",
  id: "loggeduser_div"
}
const _hoisted_3 = {
  key: 1,
  class: "navbar"
}
const _hoisted_4 = { class: "content text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "on"
}, null, -1))
const _hoisted_6 = { class: "content text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "on"
}, null, -1))
const _hoisted_8 = { class: "content text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "on"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.$route.meta.hideFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/rules",
            class: "tab text-decoration-none"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_Regolamento",
                  text: "Regolamento",
                  class: "fs_12 ff_unbounded d-block mt-1"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/profile",
            class: "tab text-decoration-none"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_Home",
                  text: "Home",
                  class: "fs_12 ff_unbounded d-block mt-1"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/ranking",
            class: _normalizeClass(["tab text-decoration-none", { 'router-link-active' : _ctx.isUrlChallenge }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_Classifica",
                  text: "Classifica",
                  class: "fs_12 ff_unbounded d-block mt-1"
                })
              ])
            ]),
            _: 1
          }, 8, ["class"])
        ]))
      : _createCommentVNode("", true)
  ]))
}